import { cn } from '@/lib/cn'
import type { Role } from '@/api/types'

const TONE_CLASS: Record<Role, string> = {
  Admin: 'wsrow__role--admin',
  Manager: 'wsrow__role--manager',
  User: 'wsrow__role--user',
}

/**
 * Tiny pill rendering the viewer's role on a tenant. Ranked by weight
 * within the clarity palette: Admin accent, Manager blue, User neutral.
 * Any unknown future role falls through to the neutral default baked into
 * `.wsrow__role`, so new values never render invisibly.
 */
export function RoleChip({
  role,
  className,
}: {
  role: Role
  className?: string
}) {
  return (
    <span className={cn('wsrow__role', TONE_CLASS[role], className)}>
      {role}
    </span>
  )
}
